<template>
  <transition
    v-if="isOpen"
    name="fade"
    appear
    @before-enter="$emit('opening')"
    @after-enter="$emit('opened')"
    @before-leave="$emit('closing')"
    @after-leave="$emit('closed')"
  >
    <dialog
      ref="drawer"
      class="app-drawer"
      :class="{ bottom: anchor === 'bottom' }"
      open
      @click.self="closeOnBackdropClick ? onClickBackdrop : undefined"
    >
      <AppCard class="content rounded-b-none">
        <slot />
      </AppCard>
    </dialog>
  </transition>
</template>

<script>
import AppCard from '@/components/App/Card.vue'

export default {
  name: 'AppDrawer',
  inheritAttrs: false,

  components: {
    AppCard,
  },

  data() {
    return {
      isOpen: ['', true].includes(this.$attrs.open),
    }
  },

  props: {
    anchor: {
      type: String,
      required: false,
      default: 'bottom',
    },

    closeOnBackdropClick: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  methods: {
    onClickBackdrop() {
      const { closeOnBackdropClick } = this

      if (closeOnBackdropClick === true) return this.close()
    },

    show() {
      return this.open(...arguments)
    },

    async open() {
      return new Promise(resolve => {
        this.$once('opened', resolve)

        this.isOpen = true
      })
    },

    hide() {
      return this.close(...arguments)
    },

    close() {
      return new Promise(resolve => {
        this.$once('closed', resolve)

        this.isOpen = false
      })
    },

    toggle() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style lang="scss" scoped>
.app-drawer {
  position: fixed;
  z-index: 10;
  top: 0;
  width: 100vw;
  height: 100vh;
  border: 0;
  padding: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: currentColor;

  > .content {
    position: absolute;
    // background-color: #fff;
    // color: #000;
    // overflow: hidden;
    // border-radius: 2rem 2rem 0rem 0rem;
  }

  &.bottom {
    > .content {
      width: 100vw;
      bottom: 0;
      max-height: 85vh;
      overflow: auto;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s ease;
  will-change: opacity;

  > .content {
    transition: transform 0.3s ease;
    will-change: transform;
  }

  &.bottom {
    > .content {
      transform: none;
    }
  }
}

.fade-enter,
.fade-leave-to {
  opacity: 0;

  &.bottom {
    > .content {
      transform: translateY(100%);
    }
  }
}
</style>
